import { useContext, useState, useEffect } from 'react';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { BuyerSurveyQuery } from 'interfaceAdapter/queries/BuyerSurvey';
import { SurveyForBuyerRepository } from 'interfaceAdapter/repositories/SurveyForBuyer';
import { useParams } from 'react-router-dom';
import { ISurvey } from 'domain/entities/Survey/Survey';
import { useForm } from 'react-hook-form';
import { useLoading } from 'application/contexts/useLoading';

export const useSurveyForm = () => {
    const diContainer = useContext(diContainerContext);
    const buyerSurveyQuery = diContainer.resolve(BuyerSurveyQuery);
    const surveyForBuyer = diContainer.resolve(SurveyForBuyerRepository);
    const { loading, setLoading } = useLoading();
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [survey, setSurvey] = useState<ISurvey | null>(null);
    const params = useParams();
    const matchId = Number(params.matchId);

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
    } = useForm();

    useEffect(() => {
        const fetchSurveyDataForBuyer = async () => {
            if (!matchId) {
                return;
            }

            try {
                setLoading(true);
                const data = await buyerSurveyQuery.fetch(matchId);

                if (!data) {
                    throw new Error('アンケート情報の取得に失敗しました');
                }

                setSurvey(data as ISurvey);
            } finally {
                setLoading(false);
            }
        };

        fetchSurveyDataForBuyer();
    }, []);

    const onSubmit = handleSubmit(async (data) => {
        try {
            setLoading(true);
            const answers = survey?.question_data.map((question) => {
                // 空文字の場合はnullに変換する必要がある
                return data[question.id] || data[question.id] === 0 ? data[question.id] : null;
            });
            answers && (await surveyForBuyer.answer(matchId, answers));
            setShowSnackbar(true);
            setTimeout(() => {
                window.location.replace('/buyer/dashboard');
            }, 1500);
        } finally {
            setLoading(false);
        }
    });

    return {
        survey,
        loading,
        showSnackbar,
        errors,
        setShowSnackbar,
        onSubmit,
        register,
        setValue,
    };
};
